import { DropdownOption } from "@/components/commons/DataTableDropdown";

export const STAGE_OPTIONS: DropdownOption<string>[] = [
  { value: "elementary", label: "ابتدایی" },
  { value: "middle", label: "متوسطه اول" },
  { value: "high", label: "متوسطه دوم" },
];

export const GRADE_OPTIONS: Record<string, DropdownOption<string>[]> = {
  elementary: [
    { value: "1", label: "اول" },
    { value: "2", label: "دوم" },
    { value: "3", label: "سوم" },
    { value: "4", label: "چهارم" },
    { value: "5", label: "پنجم" },
    { value: "6", label: "ششم" },
  ],
  middle: [
    { value: "7", label: "هفتم" },
    { value: "8", label: "هشتم" },
    { value: "9", label: "نهم" },
  ],
  high: [
    { value: "10", label: "دهم" },
    { value: "11", label: "یازدهم" },
    { value: "12", label: "دوازدهم" },
  ],
};

export const BRANCH_OPTIONS: DropdownOption<string>[] = [
  { value: "math_physics", label: "رشته ریاضی فیزیک" },
  { value: "experimental_sciences", label: "رشته علوم تجربی" },
  { value: "human_sciences", label: "رشته علوم انسانی" },
  { value: "vocational", label: "فنی حرفه ای" },
  { value: "arts", label: "هنر" },
];

export const LESSONS_DATABASE: Record<string, Record<string, DropdownOption<string>[]>> = {
  elementary: {
    "1": [
      { value: "persian_1", label: "فارسی" },
      { value: "math_1", label: "ریاضی" },
      { value: "science_1", label: "علوم" },
    ],
    "2": [
      { value: "persian_2", label: "فارسی" },
      { value: "math_2", label: "ریاضی" },
      { value: "science_2", label: "علوم" },
    ],
    "3": [
      { value: "persian_3", label: "فارسی" },
      { value: "math_3", label: "ریاضی" },
      { value: "science_3", label: "علوم" },
    ],
    "4": [
      { value: "persian_4", label: "فارسی" },
      { value: "math_4", label: "ریاضی" },
      { value: "science_4", label: "علوم" },
    ],
    "5": [
      { value: "persian_5", label: "فارسی" },
      { value: "math_5", label: "ریاضی" },
      { value: "science_5", label: "علوم" },
    ],
    "6": [
      { value: "persian_6", label: "فارسی" },
      { value: "math_6", label: "ریاضی" },
      { value: "science_6", label: "علوم" },
    ],
  },
  middle: {
    "7": [
      { value: "persian_7", label: "زبان" },
      { value: "math_7", label: "ریاضی" },
      { value: "science_7", label: "علوم" },
      { value: "arabic_7", label: "عربی" },
      { value: "other_7", label: "سایر" },
    ],
    "8": [
      { value: "persian_8", label: "زبان" },
      { value: "math_8", label: "ریاضی" },
      { value: "science_8", label: "علوم" },
      { value: "arabic_8", label: "عربی" },
      { value: "other_8", label: "سایر" },
    ],
    "9": [
      { value: "persian_9", label: "زبان" },
      { value: "math_9", label: "ریاضی" },
      { value: "science_9", label: "علوم" },
      { value: "arabic_9", label: "عربی" },
      { value: "other_9", label: "سایر" },
    ],
  },
  high: {
    "10_math_physics": [
      { value: "algebra_10", label: "آمار و احتمال" },
      { value: "geometry_10", label: "هندسه" },
      { value: "physics_10", label: "فیزیک" },
      { value: "chemistry_10", label: "شیمی" },
      { value: "other_10", label: "سایر" },
    ],
    "11_math_physics": [
      { value: "calculus_11", label: "حسابان" },
      { value: "geometry_11", label: "هندسه" },
      { value: "physics_11", label: "فیزیک" },
      { value: "chemistry_11", label: "شیمی" },
      { value: "other_11", label: "سایر" },
    ],
    "12_math_physics": [
      { value: "calculus_12", label: "حسابان" },
      { value: "geometry_12", label: "هندسه" },
      { value: "discrete_12", label: "ریاضیات گسسته" },
      { value: "physics_12", label: "فیزیک" },
      { value: "chemistry_12", label: "شیمی" },
      { value: "other_12", label: "سایر" },
    ],

    "10_experimental_sciences": [
      { value: "math_10", label: "ریاضی" },
      { value: "biology_10", label: "زیست شناسی" },
      { value: "chemistry_10", label: "شیمی" },
      { value: "physics_10", label: "فیزیک" },
      { value: "other_10", label: "سایر" },
    ],
    "11_experimental_sciences": [
      { value: "math_human_11", label: "ریاضی" },
      { value: "biology_11", label: "زیست شناسی" },
      { value: "chemistry_11", label: "شیمی" },
      { value: "physics_11", label: "فیزیک" },
      { value: "other_11", label: "سایر" },
    ],
    "12_experimental_sciences": [
      { value: "math_human_12", label: "ریاضی" },
      { value: "biology_12", label: "زیست شناسی" },
      { value: "chemistry_12", label: "شیمی" },
      { value: "physics_12", label: "فیزیک" },
      { value: "geology_12", label: "زمین شناسی" },
      { value: "other_12", label: "سایر" },
    ],

    "10_human_sciences": [
      { value: "literature_10", label: "علوم و فنون" },
      { value: "arabic_10", label: "عربی تخصصی" },
      { value: "economics_10", label: "اقتصاد" },
      { value: "sociology_10", label: "جامعه شناسی" },
      { value: "philosophy_10", label: "فلسفه" },
      { value: "logic_10", label: "منطق" },
      { value: "psychology_10", label: "روان شناسی" },
      { value: "other_10", label: "سایر" },
    ],
    "11_human_sciences": [
      { value: "literature_11", label: "علوم و فنون" },
      { value: "arabic_11", label: "عربی تخصصی" },
      { value: "economics_11", label: "اقتصاد" },
      { value: "sociology_11", label: "جامعه شناسی" },
      { value: "philosophy_11", label: "فلسفه" },
      { value: "logic_11", label: "منطق" },
      { value: "psychology_11", label: "روان شناسی" },
      { value: "other_11", label: "سایر" },
    ],
    "12_human_sciences": [
      { value: "literature_12", label: "علوم و فنون" },
      { value: "arabic_12", label: "عربی تخصصی" },
      { value: "economics_12", label: "اقتصاد" },
      { value: "sociology_12", label: "جامعه شناسی" },
      { value: "philosophy_12", label: "فلسفه" },
      { value: "logic_12", label: "منطق" },
      { value: "psychology_12", label: "روان شناسی" },
      { value: "other_12", label: "سایر" },
    ],

    "10_vocational": [
      { value: "arabic_10", label: "عربی" },
      { value: "literature_10", label: "ادبیات" },
      { value: "math_human_10", label: "ریاضی" },
      { value: "english_10", label: "انگلیسی" },
      { value: "other_10", label: "سایر" },
    ],
    "11_vocational": [
      { value: "arabic_11", label: "عربی" },
      { value: "literature_11", label: "ادبیات" },
      { value: "math_human_11", label: "ریاضی" },
      { value: "english_11", label: "انگلیسی" },
      { value: "other_11", label: "سایر" },
    ],
    "12_vocational": [
      { value: "arabic_12", label: "عربی" },
      { value: "literature_12", label: "ادبیات" },
      { value: "math_human_12", label: "ریاضی" },
      { value: "english_12", label: "انگلیسی" },
      { value: "other_12", label: "سایر" },
    ],

    "10_arts": [
      { value: "arabic_10", label: "عربی" },
      { value: "literature_10", label: "ادبیات" },
      { value: "english_10", label: "انگلیسی" },
      { value: "other_10", label: "سایر" },
    ],
    "11_arts": [
      { value: "arabic_11", label: "عربی" },
      { value: "literature_11", label: "ادبیات" },
      { value: "english_11", label: "انگلیسی" },
      { value: "other_11", label: "سایر" },
    ],
    "12_arts": [
      { value: "arabic_12", label: "عربی" },
      { value: "literature_12", label: "ادبیات" },
      { value: "english_12", label: "انگلیسی" },
      { value: "other_12", label: "سایر" },
    ],
  },
};

// Helper functions to get labels
export const getGradeLabel = (grade: number | string | null | undefined): string => {
  if (grade === null || grade === undefined || grade === "" || grade === "-") {
    return "-";
  }

  // Legacy composite values like "10_math_physics" — grade only, no branch
  const gradeStr = grade.toString().split("_")[0];

  const allGrades = [
    ...GRADE_OPTIONS.elementary,
    ...GRADE_OPTIONS.middle,
    ...GRADE_OPTIONS.high,
  ];
  const matchedGrade = allGrades.find((g) => g.value === gradeStr);
  if (matchedGrade) return matchedGrade.label;

  return gradeStr;
};

export const getBookLabel = (book: string): string => {
  // Search through all lessons database to find the book label
  for (const stage in LESSONS_DATABASE) {
    for (const grade in LESSONS_DATABASE[stage]) {
      const lessons = LESSONS_DATABASE[stage][grade];
      const foundLesson = lessons.find(lesson => lesson.value === book);
      if (foundLesson) return foundLesson.label;
    }
  }
  return book;
};
